import { DomainBase } from "./DomainBase";

 export class BrandClass extends DomainBase {
    constructor() {
        super();
        this.name = "";
        this.isDeleted=true
       
    }
}